function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.5258 59.999H1.57899C0.70704 59.999 0 59.2919 0 58.42V1.57899C0 0.707039 0.70704 0 1.57899 0H30.5258V59.999Z",
  fill: "#006847"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M61.0527 0.000976562H30.5264V60.0001H61.0527V0.000976562Z",
  fill: "#F5F5F5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M89.9981 59.9988H61.0513V0H89.9981C90.87 0 91.577 0.707039 91.577 1.57899V58.42C91.577 59.2921 90.87 59.9988 89.9981 59.9988Z",
  fill: "#CE1126"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M48.5117 31.4121L45.7886 32.774V34.1356H47.1502L48.5117 31.4121Z",
  fill: "#FFD250"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7883 37.5391C45.412 37.5391 45.1074 37.2345 45.1074 36.8582V34.135C45.1074 33.7587 45.412 33.4541 45.7883 33.4541C46.1647 33.4541 46.4693 33.7587 46.4693 34.135V36.8582C46.4693 37.2345 46.1647 37.5391 45.7883 37.5391Z",
  fill: "#00C3A0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7886 34.8164C43.1144 34.8164 40.5322 33.7845 38.5171 31.9109C38.2418 31.655 38.2259 31.2241 38.4817 30.949C38.7396 30.6745 39.17 30.6598 39.4436 30.9136C41.2061 32.5525 43.4594 33.4547 45.7884 33.4547C48.1173 33.4547 50.3706 32.5525 52.1331 30.9136C52.4077 30.6591 52.8379 30.673 53.0951 30.949C53.351 31.2243 53.3351 31.6552 53.0596 31.9109C51.0449 33.7847 48.4627 34.8164 45.7886 34.8164Z",
  fill: "#00C3A0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7888 37.5393C44.0434 37.5393 42.3528 37.0293 40.8994 36.064L41.6533 34.9297C44.1107 36.5625 47.4669 36.5625 49.9241 34.9297L50.678 36.064C49.2247 37.0295 47.5341 37.5393 45.7888 37.5393Z",
  fill: "#00AADC"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M44.7104 28.3481L43.2071 30.6746L42.9517 31.4403L46.8664 30.5326L44.7104 28.3481Z",
  fill: "#732D37"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M41.6219 32.1886C39.8222 32.1886 37.6619 30.674 37.0889 27.2992L38.4319 27.0719C38.9081 29.8782 40.6344 30.8289 41.6711 30.8264C41.989 30.8176 42.3206 30.708 42.3467 30.4833C42.3773 30.2147 42.3846 30.151 41.6726 29.9102C41.2855 29.7791 40.8468 29.631 40.5389 29.2787C39.2935 27.8566 40.9796 26.3514 41.7897 25.6281C41.9326 25.5004 41.9918 25.392 41.9766 25.3509C41.9321 25.2344 41.6649 25.0584 41.3637 25.0584C40.4987 25.0584 39.8424 24.5698 39.6518 23.7839C39.4536 22.9701 39.828 22.1124 40.5407 21.7441L41.1658 22.9541C40.9988 23.0405 40.9326 23.2865 40.975 23.4621C40.9916 23.5326 41.0322 23.6968 41.364 23.6968C42.1977 23.6968 42.9909 24.1888 43.2489 24.8656C43.3592 25.1541 43.5254 25.9041 42.6971 26.6441C41.8028 27.4427 41.2676 28.0436 41.5642 28.3821C41.6312 28.4584 41.9192 28.5563 42.1093 28.6201C42.7223 28.8276 43.8633 29.2132 43.6998 30.6393C43.5973 31.5361 42.7969 32.1584 41.7092 32.1879C41.6799 32.1879 41.6506 32.1886 41.6219 32.1886Z",
  fill: "#AAD264"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M47.1502 24.604C47.1502 24.604 48.5119 21.8808 45.7886 20.5191C45.7886 20.5191 55.3199 19.1575 53.9583 31.4122L53.9577 31.4116C53.0641 30.6967 51.7373 29.3901 51.2635 28.3484L47.1502 25.9655V24.604Z",
  fill: "#874150"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7886 27.3271L52.5966 31.412C52.5966 31.412 52.5966 31.412 49.8734 32.7737L45.7886 28.689V27.3271Z",
  fill: "#732D37"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M43.0654 23.2424C43.8174 23.2424 44.4271 23.8521 44.4271 24.604L44.4257 24.6055C43.6133 25.4178 43.4121 26.6586 43.9258 27.6862L44.2334 28.3016C44.3616 28.5581 44.5305 28.7924 44.7333 28.9953L48.5121 32.7741V30.8923C48.5121 28.5479 47.9664 26.2358 46.9179 24.139C46.2259 22.7551 44.8115 21.8809 43.2643 21.8809H43.0656V23.2427H43.0654V23.2424Z",
  fill: "#783C46"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M43.0653 21.8804L41.7036 23.242V24.6037C41.7036 24.6037 43.3234 23.7826 43.8693 23.5209C44.2508 23.3381 44.1814 22.9058 43.9625 22.6974C43.792 22.5354 43.0653 21.8804 43.0653 21.8804Z",
  fill: "#FFD250"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7886 40.2623C39.4067 40.2623 34.2148 35.0704 34.2148 28.6885H35.5765C35.5765 34.3199 40.1573 38.9008 45.7888 38.9008C51.4203 38.9008 56.0011 34.3199 56.0011 28.6885H57.3628C57.3624 35.0704 52.1706 40.2623 45.7886 40.2623Z",
  fill: "#AAD264"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M35.6506 33.6532C36.1609 33.6532 36.5746 33.2395 36.5746 32.7292C36.5746 32.2189 36.1609 31.8052 35.6506 31.8052C35.1403 31.8052 34.7266 32.2189 34.7266 32.7292C34.7266 33.2395 35.1403 33.6532 35.6506 33.6532Z",
  fill: "#FFE15A"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M37.693 36.9154C38.2034 36.9154 38.617 36.5017 38.617 35.9914C38.617 35.4811 38.2034 35.0674 37.693 35.0674C37.1827 35.0674 36.769 35.4811 36.769 35.9914C36.769 36.5017 37.1827 36.9154 37.693 36.9154Z",
  fill: "#FFE15A"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M41.0114 39.3822C41.5217 39.3822 41.9354 38.9685 41.9354 38.4582C41.9354 37.9479 41.5217 37.5342 41.0114 37.5342C40.5011 37.5342 40.0874 37.9479 40.0874 38.4582C40.0874 38.9685 40.5011 39.3822 41.0114 39.3822Z",
  fill: "#FFE15A"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M56.0246 33.6532C56.5349 33.6532 56.9486 33.2395 56.9486 32.7292C56.9486 32.2189 56.5349 31.8052 56.0246 31.8052C55.5143 31.8052 55.1006 32.2189 55.1006 32.7292C55.1006 33.2395 55.5143 33.6532 56.0246 33.6532Z",
  fill: "#FFE15A"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M53.9806 36.9154C54.4909 36.9154 54.9046 36.5017 54.9046 35.9914C54.9046 35.4811 54.4909 35.0674 53.9806 35.0674C53.4703 35.0674 53.0566 35.4811 53.0566 35.9914C53.0566 36.5017 53.4703 36.9154 53.9806 36.9154Z",
  fill: "#FFE15A"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M50.6628 39.3822C51.1731 39.3822 51.5868 38.9685 51.5868 38.4582C51.5868 37.9479 51.1731 37.5342 50.6628 37.5342C50.1525 37.5342 49.7388 37.9479 49.7388 38.4582C49.7388 38.9685 50.1525 39.3822 50.6628 39.3822Z",
  fill: "#FFE15A"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M46.4694 38.2199H45.1078C44.3558 38.2199 43.7461 37.6102 43.7461 36.8583C43.7461 36.1063 44.3558 35.4966 45.1078 35.4966H46.4694C47.2214 35.4966 47.8311 36.1063 47.8311 36.8583C47.8311 37.6104 47.2214 38.2199 46.4694 38.2199Z",
  fill: "#FFB478"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M51.2635 28.3483C51.7175 29.6815 52.6819 30.9013 53.9577 31.4114L53.9583 31.412C55.3199 19.1576 45.7886 20.5191 45.7886 20.5191C52.5966 20.5191 51.2635 28.3483 51.2635 28.3483Z",
  fill: "#9B4B5A"
});

var SvgMxn = function SvgMxn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 60,
    viewBox: "0 0 92 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMxn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MXN.c12da0cd.svg";
export { ForwardRef as ReactComponent };